import React, { FC, useState } from 'react';

import { LocationAnimationErrorBox } from '@components/views/components/listing/ListingStyle';
import { VehicleOfficeSearchViewModel } from '@api/index';

import ResponsiveListingSearchLocation from './ResponsiveListingSearchLocation';
import { CarRentalTypes } from '.';

interface IMobileCarRentalSelection {
  label: string;
  onChange?: (data: CarRentalTypes) => void;
  history?: VehicleOfficeSearchViewModel[];
  clearPastFlightSearch?: () => void;
  removePastFlightSearch?: (item: VehicleOfficeSearchViewModel) => void;
  isLocationError?: boolean;
  setIsLocationError?: (value: boolean) => void;
  activeLocation?: CarRentalTypes;
}

const MobileCarRentalSelection: FC<IMobileCarRentalSelection> = ({
  activeLocation,
  onChange,
  history,
  clearPastFlightSearch,
  removePastFlightSearch,
  isLocationError,
  setIsLocationError,
  label,
}) => {
  const [isShowSearchListingLocation, setIsSHowSearchListingLocation] =
    useState(false);
  const [inputLocation, setInputLocation] = useState<string>(
    activeLocation?.text || ''
  );
  const [openAutoCompleteResult, setOpenAutoCompleteResult] =
    useState<boolean>(false);

  /**
   * Handling Clicking on the apply button
   */
  const applySearchLocationHandler = (
    currentSelectedLocation: VehicleOfficeSearchViewModel
  ) => {
    if (!currentSelectedLocation?.text) {
      setIsLocationError?.(true);
      return;
    }

    setInputLocation(currentSelectedLocation?.text || '');
    setIsSHowSearchListingLocation(false);
    onChange?.(currentSelectedLocation);
    isLocationError && setIsLocationError?.(false);
  };

  /**
   * Handling Clicking on close location search icon
   */
  const handleCloseLocationSearch = () => {
    setIsSHowSearchListingLocation(false);
    setOpenAutoCompleteResult(false);
  };

  /**
   * Handling Clicking on the location search icon
   */
  const handleOpenLocationSearch = () => {
    setIsSHowSearchListingLocation(true);
  };

  return (
    <LocationAnimationErrorBox hasError={isLocationError || false}>
      <ResponsiveListingSearchLocation
        type='hotel'
        showLocationModal={handleOpenLocationSearch}
        width='100%'
        height='100%'
        placement='top'
        title='Konum Arama'
        open={isShowSearchListingLocation}
        locationInput={inputLocation}
        locationInputError={isLocationError || false}
        handleUpdateButton={applySearchLocationHandler}
        handleCloseLocationSearch={handleCloseLocationSearch}
        openAutoCompleteResultModal={openAutoCompleteResult}
        setOpenAutoCompleteResultModal={setOpenAutoCompleteResult}
        pastSearchesData={history}
        onRemoveItem={removePastFlightSearch}
        onClearClick={clearPastFlightSearch}
        error={isLocationError}
        label={label}
      />
    </LocationAnimationErrorBox>
  );
};

export default MobileCarRentalSelection;
